var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('v-container',[_c('v-row',[_c('v-col',{attrs:{"cols":"6"}},[_vm._v(" Welcome to the dashboard ")])],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }